var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolicitacaoUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8065 4.32227C15.7361 4.32227 13.7505 5.14473 12.2865 6.60872C10.8225 8.07272 10 10.0583 10 12.1287V51.8707C10 53.9411 10.8225 55.9267 12.2865 57.3907C13.7505 58.8547 15.7361 59.6771 17.8065 59.6771H46.1936C48.264 59.6771 50.2496 58.8547 51.7136 57.3907C53.1776 55.9267 54 53.9411 54 51.8707V21.2069C54 20.1682 53.6744 19.1555 53.0689 18.3114L44.5131 6.39453C44.0534 5.75374 43.4479 5.23159 42.7464 4.87124C42.045 4.5109 41.2678 4.32272 40.4793 4.32227H17.8065ZM14.2581 12.1287C14.2581 10.17 15.8477 8.58033 17.8065 8.58033H38.3871V21.0622C38.3871 22.2374 39.3409 23.1912 40.5162 23.1912H49.742V51.8707C49.742 53.8294 48.1523 55.4191 46.1936 55.4191H17.8065C15.8477 55.4191 14.2581 53.8294 14.2581 51.8707V12.1287Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2499 34.25H41.7499M21.6602 34.8223L31.3985 47.4533C31.4693 47.5455 31.5604 47.6203 31.6646 47.6717C31.7689 47.7232 31.8836 47.7499 31.9999 47.7499C32.1162 47.7499 32.2309 47.7232 32.3352 47.6717C32.4395 47.6203 32.5306 47.5455 32.6013 47.4533L42.3396 34.8223C42.4354 34.6977 42.4909 34.5468 42.4989 34.3898C42.5068 34.2328 42.4668 34.0771 42.3841 33.9434L39.0809 28.6114C39.0129 28.5011 38.9178 28.4099 38.8046 28.3467C38.6915 28.2834 38.5641 28.2501 38.4345 28.25H25.5654C25.4358 28.2501 25.3084 28.2834 25.1952 28.3467C25.0821 28.4099 24.987 28.5011 24.919 28.6114L21.6157 33.9434C21.5331 34.0771 21.493 34.2328 21.501 34.3898C21.5089 34.5468 21.5645 34.6977 21.6602 34.8223Z",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 29L36.5 34.25M36.5 34.25L32 28.25L27.5 34.25M36.5 34.25L32 47L27.5 34.25M25.25 29L27.5 34.25",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitacaoUpgrade);
export default __webpack_public_path__ + "static/media/solicitacao_upgrade.31f1d069e2abd7e4d5c17d5db4cca0c9.svg";
export { ForwardRef as ReactComponent };